import React from 'react';
import ReportFrame from './ReportFrame';

export default class AdjustedPricingSummary extends React.Component {
  static defaultProps = {
    OpportunityId: 0,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {
      OpportunityId: this.props.OpportunityId,
      // CurrencyId: 29,
      // StatusList: [5],
    };
    return (
      <ReportFrame
        reportName='Pricing Summary Adjusted'
        reportParams={reportParams}
        id='pricingReportAdjusted'
        name='pricingReportAdjusted'
        title='Pricing Report Adjusted'
      />
    );
  }
}
